import Swiper, { Pagination, Thumbs, Navigation } from 'swiper'
;(() => {
    Swiper.use([Pagination, Thumbs, Navigation])
    new Swiper('.swiper-news', {
        loop: true,
        spaceBetween: 15,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        }
    })

    document.querySelectorAll('.gallery-slider').forEach(gallery => {
        const thumbs = gallery.querySelector('.gallery-slider__thumbs')
        const main = gallery.querySelector('.gallery-slider__main')

        if (!thumbs || !main) return

        const swiperThumbs = new Swiper(thumbs, {
            loop: false,
            spaceBetween: 8,
            slidesPerView: 'auto',
            freeMode: true,
            watchSlidesProgress: true
        })

        new Swiper(main, {
            loop: true,
            spaceBetween: 10,
            freeMode: true,
            navigation: {
                nextEl: gallery.querySelector('.gallery-slider__next'),
                prevEl: gallery.querySelector('.gallery-slider__prev')
            },
            thumbs: {
                swiper: swiperThumbs
            }
        })
    })
})()
